import { render, staticRenderFns } from "./home-actions.vue?vue&type=template&id=0fbae5b2&scoped=true&"
import script from "./home-actions.vue?vue&type=script&lang=js&"
export * from "./home-actions.vue?vue&type=script&lang=js&"
import style0 from "./home-actions.vue?vue&type=style&index=0&id=0fbae5b2&lang=less&scoped=true&"
import style1 from "./home-actions.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbae5b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbae5b2')) {
      api.createRecord('0fbae5b2', component.options)
    } else {
      api.reload('0fbae5b2', component.options)
    }
    module.hot.accept("./home-actions.vue?vue&type=template&id=0fbae5b2&scoped=true&", function () {
      api.rerender('0fbae5b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/home-actions.vue"
export default component.exports